import './style.css'
import * as THREE from 'three'
// import * as dat from 'dat.gui'
// import {GLTFLoader} from 'three/examples/jsm/loaders/GLTFLoader.js'
// import vertShader from "./shaders/vertShader.glsl"
// import fragShader from "./shaders/fragShader.glsl"
import {sphereMesh,copy,copy2,roomMesh,planeMesh, timeUpdater,sphereMeshes,lineMeshes} from "./sphere.js"
import {sound,analyser} from "./sound.js"
import { gsap } from "gsap";

import {setup} from "./setup"

//gsap?

// should i trigger a turn on animation when i get close to the scroll point
// or should i just use the scroll point directly?
// maybe start with scroll point 

// window.addEventListener("scroll",()[]

const bodyContainer = document.getElementsByClassName("bodyContainer")[0];

bodyContainer.addEventListener("scroll", (e)=>{
    // e.preventDefault();
    console.log();
    updateScroll();
});




  function updateScroll(){

    const scrollTop = bodyContainer.scrollTop;
    const maxScroll = bodyContainer.scrollHeight - window.innerHeight;
    const scrollValue = maxScroll > 0 ? scrollTop / maxScroll : 0;
    // console.log(scrollTop,maxScroll,document.documentElement.scrollHeight,window.innerHeight,scrollValue)

    // min,max range
    // 

    const minScroll = window.innerHeight;
    // const maxRange = maxScroll;
    const remapped_scroll = (scrollTop-minScroll)/(maxScroll-minScroll);

    updateAnimationSystem(scrollValue);
  }
  // maybe for scale too??
  let timelines = [];
  // timeline for each spheremesh, seek to the spots..
  // this gives easing also
  for(let j = 0;j < 3;j++){
    let brightness = sphereMeshes[j].material.uniforms.brightness;
    brightness.value = 1;
    let tl = gsap.timeline();
        for(let i=0;i<3;i++){
            if(j==i){
                tl.to(brightness,{duration:1/3,value:1 })
            }else {
                tl.to(brightness,{duration:1/3,value:0 })
            }
        }
        tl.pause();
        timelines.push(tl);
  }

  let horizonOffset = roomMesh.material.uniforms.horizonOffset;
  let tHO = gsap.timeline();
  tHO.to(horizonOffset,{duration:1,value:-1 })
  tHO.pause();
  timelines.push(tHO);
  // allow clicking on the cubes (low poly twin?)
  // use raycasting with the bvh optimization

  // do similar for the lines and movement for the cubes too..


  // could use a set of cosines to get smooth paths that fit points. 
  //
  // 1,1,0,0 
  // 1,0,1,0
  // 1,0,0,1

  // could stop scrolling behavior and use scrolls as intentions to move to the next display.. 
  // then you could animate the scroll value and the brightness values using gsap

  lineMeshes.forEach((lineMesh)=>{
    lineMesh.basePositon = lineMesh.position.clone();
  })

  let OffsetVector = new THREE.Vector3(0,0,0);
  let cameraDirection_val = setup.camera;
//   console.log(camera);


function updateAnimationSystem(scrollPoint){
    // do the currently available animations.. 
    timelines.forEach((timeline,index)=>{
        // // start full brightness, at each display highlight that index up
        // let timeline = timelines[index];
        timeline.seek(scrollPoint)
        // sphereMesh.material.uniforms.brightness.value = scrollPoint;
    })

    // lineMeshes.forEach((lineMesh)=>{
    //     lineMesh.position.copy(lineMesh.basePositon)
    //     // OffsetVector = cameraDirection_val*camera.scrollPoint;
    //     lineMesh.position.add(OffsetVector)
    // })
    
}

updateScroll();


function main() {

// BASIC SETUP

var {scene,camera,renderer} = setup;

// RENDER LOOP


var up = new THREE.Vector3(1.,0.,1.);

var target = new THREE.Vector3(1.,0.,0.);


var index = 0.;
var moving = false;
const clock = new THREE.Clock();
var clockTimes = [];
for(let i= 0;i< sphereMeshes.length;i++){
    clockTimes.push(0);
}

function render(time)
{   


    // clockTimes.forEach((clockTime)=>{
    //     clockTime += delta;
    // }) 
    timeUpdater.updateTime(time*0.001);

    const delta = clock.getDelta();
    for(let i=0;i<clockTimes.length;i++){
        // scale this based on brightness. 
        var brightness = sphereMeshes[i].material.uniforms.brightness.value;
        clockTimes[i] += delta*brightness;
    }

    // console.log(clockTimes);


    if(index==0){
        sphereMeshes.forEach((m)=>{
            m.position.set(0, -10, 0);
        })
        index += 1.;
    } else {
        sphereMeshes.forEach((m,ind)=>{
            m.position.set(0., Math.cos(time * 0.001*1. + clockTimes[ind]*0.0 + m.offset.x) * 0.25, 0.);
            m.position.add(m.offset);
        })
        // console.log("hi")

    }

    sphereMeshes.forEach((m,ind) => {
        m.rotation.set(clockTimes[ind] * 0.1 + clockTimes[ind] * 0.21 * m.offset.x+m.offset.x,
            clockTimes[ind] * 0.25 + clockTimes[ind] * 0.13*m.offset.x + m.offset.x+2,
              0.);
    })

    renderer.render(scene,camera);
    requestAnimationFrame ( render );
}

requestAnimationFrame ( render );

}

main();




